import { Component, computed, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { useBreakpoint } from '../../composables/useBreakpoint';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  standalone: true,
  selector: 'app-ai-assistant-v2',
  imports: [CommonModule, TranslatePipe],
  templateUrl: './ai-assistant-v2.component.html',
  styleUrl: './ai-assistant-v2.component.scss',
})
export class AiAssistantV2Component {
  @Input() userName: string = 'Pavel';

  @Input() sheetProgress: number = 1;

  @Input() compact: boolean | null = null;

  get isCompact(): boolean {
    return this.sheetProgress > 0.5;
  }

  readonly currentBreakpoint = useBreakpoint().currentBreakpoint;
  readonly isMobile = computed(
    () =>
      this.currentBreakpoint() === 'XSmall' ||
      this.currentBreakpoint() === 'Small'
  );

  // Apply internal parallax transform based on viewport
  @HostBinding('style.transform')
  get transform(): string {
    const vh = window.innerHeight || 800;
    const visibleHeight = Math.round(vh * 0.7);
    const maxOffset = Math.max(0, visibleHeight - 50);
    const parallax = 0.35; // 35% of sheet travel
    const y =
      -(maxOffset * parallax) * Math.max(0, Math.min(1, this.sheetProgress));
    return `translateY(${y}px)`;
  }

  // Greeting should be visible when the sheet is down (near bottom/peek)
  get showGreeting(): boolean {
    return this.sheetProgress < 0.1; // threshold to account for drag jitter
  }
}
